import React from "react";
import cn from "classnames";

import "styles/components/sr-only.scss";

const SrOnly = ({ as: Element = "span", children, contained, fullWidth, ...rest }) => {
  return (
    <Element
      className={cn({
        "otrl-jp__sr-only": !contained,
        "otrl-jp__sr-contained": contained,
        "otrl-jp__sr-contained--fullWidth": fullWidth,
      })}
      {...rest}
    >
      {children}
    </Element>
  );
};

SrOnly.containerClass = "otrl-jp__sr-container";
SrOnly.containedClass = "otrl-jp__sr-contained";

export default SrOnly;
